<template>
	<div class="box">
		<div class="row">
			<div class="col-3"><label for="compatibilite">{{ $t('pax.compatibilite_minimum') }}</label></div>
			<div class="col-3"><label for="indicator">{{ $t('pax.indicateur_minimum') }}</label></div>
			<div class="col-3"><label for="general">{{ $t('pax.compatibilite_generale') }}</label></div>
		</div>
		<div class="row">
			<div class="col-3">
				<e-select
                    v-model="grade_selected"
                    id="compatibilite"
                    :options="all_grades"
                    :searchable="true"
                    :show-labels="false"
                >
                    <template slot="option" slot-scope="{ option }"><span :class="'tags-fill '+option"></span></template>
                    <template slot="singleLabel" slot-scope="{ option }"><span :class="'tags-fill '+option"></span></template>
                    <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                </e-select>
			</div>
			<div class="col-3">
				<e-select
                    v-model="indicator_selected"
                    id="indicator"
                    :options="all_grades"
                    :searchable="true"
                    :show-labels="false"
                >
                    <template slot="option" slot-scope="{ option }"><span :class="'tags-fill '+option"></span></template>
                    <template slot="singleLabel" slot-scope="{ option }"><span :class="'tags-fill '+option"></span></template>
                    <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                </e-select>
			</div>
			<div class="col-3">
				<e-select
                    v-model="general_selected"
                    id="general"
                    :options="all_grades"
                    :searchable="true"
                    :show-labels="false"
                >
                    <template slot="option" slot-scope="{ option }"><span :class="'tags-fill '+option"></span></template>
                    <template slot="singleLabel" slot-scope="{ option }"><span :class="'tags-fill '+option"></span></template>
                    <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                </e-select>
			</div>
			<div class="col-3">
            	<button @click.prevent="submit" class="btn btn-block btn-primary">{{ $t('global.rechercher') }}</button>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<CustomTable
		            id_table="pax_compatibilite_mare"
		            ref="pax_compatibilite_mare"
		            :items="stallions"
		            :busy.sync="table_busy"
		            primaryKey="mare.horse_id"
		            :hide_if_empty="true"
		            :hrefsRoutes="config_table_hrefs"
					:externSlotColumns="['color_badge','color_indicator','color_general']"
		        >
		            <template v-slot:[`custom-slot-cell(color_badge)`]="{ data }">
		            	<div :class="'tags-fill '+data.result.result_all_color_grade"></div>
					</template>
					<template v-slot:[`custom-slot-cell(color_indicator)`]="{ data }">
		            	<div :class="'tags-fill '+data.result.result_genetic_indicator_color"></div>
					</template>
					<template v-slot:[`custom-slot-cell(color_general)`]="{ data }">
		            	<div :class="'tags-fill '+data.result.result_color_general"></div>
					</template>
		    	</CustomTable>
		    </div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import PaxMixin from "@/mixins/Pax.js"
	import TiersMixin from "@/mixins/Tiers.js"
	import Navigation from "@/mixins/Navigation.js"

	export default {
		name: 'PaxCompatibilites',
		mixins: [PaxMixin, TiersMixin, Navigation],
		props: ['horse_id'],
		data () {
			return {
				age: '',
				all_cp: [],
				cp_selected: '',
				all_grades: ['dark_green','green','yellow','orange','red'],
				grade_selected: null,
				indicator_selected: null,
				general_selected: null,
				config_table_hrefs: {
					'stallion.horse_nom': {
						routeUniqueName: 'StallionFiche',
						routeName: 'horseFiche',
						params: {
							horse_id: 'stallion.horse_id'
						}
					}
				},
				table_busy: false,
				stallions: [],
				events_tab: {
					"TableAction::goToPrintSimulation": (stallion) => {
						this.printSimulationCroisement(this.horse_id, stallion.stallion.horse_id)
					}
				}
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.all_cp = await this.getTiersCodePostal()
			},
			async submit() {
				this.table_busy = true
				this.stallions = await this.getMareCompatibilite(this.horse_id, this.grade_selected, this.indicator_selected, this.general_selected)
				this.table_busy = false
			}
		},

		components: {
            CustomTable: () => import('GroomyRoot/components/Table/CustomTable')
		}
	}

</script>